module.exports = " <div> <send-delayed-verification></send-delayed-verification> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/client/pages/UserPending.vue
// module id = 337
// module chunks = 0